import { Divider as CXDivider } from '@sanlamcx/react-ui-next-divider';

export const Divider = CXDivider;
